<template>
<div class="chapter">
<div class="inner_page">
<p class="P_p1"><span><span style=" font-size: 1.33em;">Readers love</span></span></p>
<p class="P_p2"><span><span style=" font-size: 1.50em;">M</span><span style=" font-size: 1.17em;">ARY</span><span style=" font-size: 1.50em;"> C</span><span style=" font-size: 1.17em;">ALMES</span></span></p>
<p class="P_p3"><span style=" font-style: italic; font-size: 1.33em;">A Matter of Time, Vol. 1 &amp; 2</span></p>
<p class="P_p4">“…a very readable and entertaining package.”</p>
<p class="P_p5">—Book Wenches</p>
<p class="P_p3"><span style=" font-style: italic; font-size: 1.33em;">But For You</span></p>
<p class="P_p4">“For all fans of Jory and Sam, this book is a must have!”</p>
<p class="P_p6">—Pants Off Reviews</p>
<p class="P_p4">“…everything I hoped it would be plus two.”</p>
<p class="P_p5">—Joyfully Reviewed</p>
<p class="P_p3"><span style=" font-style: italic; font-size: 1.33em;">Acrobat</span></p>
<p class="P_p4">“The only complaint I had was that I wanted more.”</p>
<p class="P_p6">—Poetry Works</p>
<p class="P_p4">“…a very satisfying story and a new couple to love.”</p>
<p class="P_p6">—Scattered Thoughts and Rogue Words</p>
<p class="P_p4">“This is going to be a comfort read for me, one of those stories that I return to when I need a little pick me up.”</p>
<p class="P_p6">—Guilty Pleasures</p>
<p class="P_p4">“…a delightful romance. Highly recommended.”</p>
<p class="P_p6">—Twlib Reviews</p>
<p class="P_p4">“…a story of courage.”</p>
<p class="P_p6">—The Novel Approach</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?22d87e51